import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-left":"10px"} }
const _hoisted_2 = { class: "tb_column_content" }
const _hoisted_3 = { style: {"margin-left":"10px"} }
const _hoisted_4 = { class: "tb_column_content" }
const _hoisted_5 = { style: {"margin-left":"10px"} }
const _hoisted_6 = { class: "tb_column_content" }
const _hoisted_7 = { style: {"margin-left":"10px"} }
const _hoisted_8 = { style: {"margin-left":"10px"} }
const _hoisted_9 = { style: {"margin-left":"10px"} }
const _hoisted_10 = { class: "tb_column_content" }
const _hoisted_11 = { style: {"margin-left":"10px"} }
const _hoisted_12 = { class: "tb_column_content" }
const _hoisted_13 = { style: {"margin-left":"10px"} }
const _hoisted_14 = { class: "tb_column_content" }
const _hoisted_15 = { style: {"margin-left":"10px"} }
const _hoisted_16 = {
  class: "tb_column_content action-content",
  style: {"justify-content":"center"}
}
const _hoisted_17 = { class: "pagination-container" }

import {ref, toRefs} from 'vue';
import dayjs from 'dayjs';

// 格式化时间的函数

export default /*@__PURE__*/_defineComponent({
  __name: 'tb_content',
  props: {
    tableData: {},
    handleEdit: { type: Function },
    handleDelete: { type: Function },
    total: {},
    currentPage: {},
    pageSize: {}
  },
  emits: ["page-change"],
  setup(__props: any, { emit: __emit }) {

const formatDate = (date: string) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};


// 定义 Props 接收父组件传来的数据和方法
const props = __props

const emit = __emit

const internalPage = ref(props.currentPage || 1)
const internalSize = ref(props.pageSize || 10)

const handleSizeChange = (val: number) => {
  internalSize.value = val
  emit('page-change', internalPage.value, internalSize.value)
}

const handleCurrentChange = (val: number) => {
  internalPage.value = val
  emit('page-change', internalPage.value, internalSize.value)
}

const formatIdCard = (idCard: string) => {
  if (!idCard) return '';
  // 保留前3位和后3位，中间用 * 替换
  return idCard.replace(/(\d{3})\d{10}(\w{3})/, '$1**********$2');
}

const formatPhone = (phone: string) => {
  if (!phone) return '';
  // 保留前3位和后4位，中间4位用 * 替换
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

const formatPrice = (price: number) => {
  if (!price) return 0;
  // 保留前3位和后4位，中间4位用 * 替换
  return Number(price).toFixed(2);
}

const changeDrange = (index: number) => {
  tableData.value[index].isD = true;
}

const formatState = (state: string) => {
  if (!state) return '待支付';
  if (state === "0") {
    return "支付成功"
  } else if (state === "1") {
    return "支付同步中"
  } else if (state === "2") {
    return "支付失败"
  } else if (state === "3") {
    return "发起退款"
  } else if (state === "4") {
    return "退款成功"
  } else if (state === "5") {
    return "退款失败"
  } else if (state === "6") {
    return "已解绑"
  } else if (state === "7") {
    return "订单完成"
  }else if (state === "8") {
    return "支付失败订单完成"
  }else if (state === "9") {
    return "支付失败订单已解绑"
  }else if (state === "S") {
    return "支付成功"
  }else if (state === "F") {
    return "支付失败"
  }
  return;
}

const formatBcakState = (state: string) => {
  if (!state) return '';
  if (state === "-1") {
    return "账单退款中"
  } else if (state === "2") {
    return "账单退款失败"
  } else if (state === "4") {
    return "退款成功"
  } else if (state === "0") {
    return "账单终止"
  } else if (state === "3") {
    return "账单终止失败"
  }
  return;
}
// 解构 props 以便在模板中使用
const {tableData, handleEdit, handleDelete} = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: _unref(tableData),
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "请求流水号",
          "header-align": "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(scope.row.reqSeqId), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "身份证号",
          "header-align": "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(formatIdCard(scope.row.idCardNo)), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "手机号",
          align: "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(scope.row.phone), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "金额(元)",
          align: "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(formatPrice(scope.row.transAmt)), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "支付日期",
          "header-align": "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(formatDate(scope.row.payTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "退款日期",
          "header-align": "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", _hoisted_9, _toDisplayString(scope.row.rePayTime ? formatDate(scope.row.rePayTime) : scope.row.rePayTime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "支付平台",
          "header-align": "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(scope.row.type == "0" ? "汇付" : "宝付"), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          "header-align": "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(scope.row.gong == "by" ? "邦远" : "灏天"), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "订单状态",
          "header-align": "center",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(scope.row.state? formatState(scope.row.state):formatBcakState(scope.row.backStatus)), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          "header-align": "center",
          "min-width": "280",
          "class-name": "action-column"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                disabled: scope.row.state==6||scope.row.state==3||scope.row.backStatus==0,
                onClick: ($event: any) => (_unref(handleDelete)(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" 退订 ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              (!scope.row.isD)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    disabled: scope.row.state==4||scope.row.state==6||scope.row.state==3||scope.row.backStatus==0||scope.row.backStatus==4,
                    onClick: ($event: any) => (_unref(handleEdit)(scope.$index, scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" 退费 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "small",
                    onClick: ($event: any) => (_unref(handleEdit)(scope.$index, scope.row))
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" 退费 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])),
              _createVNode(_component_el_button, {
                size: "small",
                color: "red",
                onClick: ($event: any) => (changeDrange( scope.$index))
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" 紧急 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_pagination, {
        "current-page": internalPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((internalPage).value = $event)),
        "page-size": internalSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((internalSize).value = $event)),
        "page-sizes": [10, 20, 50, 100],
        total: props.total || 0,
        layout: "total, sizes, prev, pager, next, jumper",
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ], 64))
}
}

})